export default "__VITE_ASSET__sc$5VPx3__"